/**
 * Stripe Payment Configuration for Nailed It by Kylee
 * 
 * HOW TO CONNECT YOUR LIVE STRIPE ACCOUNT:
 * 1. Get your Stripe Publishable Key from https://dashboard.stripe.com/apikeys
 * 2. In Cloudflare Pages Settings -> Environment Variables, add:
 *    - VITE_STRIPE_PUBLISHABLE_KEY = pk_live_... (or pk_test_...)
 *    - STRIPE_SECRET_KEY = sk_live_... (or sk_test_...)
 * 3. Or if you prefer Stripe Payment Links (No-Code Stripe), simply paste your Payment Link in STRIPE_PAYMENT_LINK below!
 */

export const STRIPE_CONFIG = {
  // Replace with your real Stripe Publishable Key when ready (or set in .env / Cloudflare env vars)
  publishableKey: (import.meta as any).env?.VITE_STRIPE_PUBLISHABLE_KEY || '',
  
  // Optional: Direct Stripe Buy Button / Payment Link URL (e.g., https://buy.stripe.com/...)
  stripePaymentLink: (import.meta as any).env?.VITE_STRIPE_PAYMENT_LINK || '',
  
  // Cloudflare Pages Function endpoint for serverless checkout sessions
  apiEndpoint: '/api/create-checkout-session',
  
  // Currency code
  currency: 'usd',
  
  // Default nail set price
  standardSetPrice: 30.00,
};

export const isStripeConfigured = (): boolean => {
  return Boolean(STRIPE_CONFIG.publishableKey || STRIPE_CONFIG.stripePaymentLink);
};
